import React, { useEffect, useState } from 'react';
import { useLanguage } from './LanguageContext';
const STORAGE_KEY = 'eiis_cookie_consent';
type Choice = 'all' | 'essential_only';
export function CookieConsentBanner() {
  const {
    t
  } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    try {
      const existing = localStorage.getItem(STORAGE_KEY);
      if (!existing) {
        setIsVisible(true);
        // Trigger fade-in on next frame
        requestAnimationFrame(() => setIsMounted(true));
      }
    } catch {
      // If localStorage is unavailable, show banner anyway
      setIsVisible(true);
      requestAnimationFrame(() => setIsMounted(true));
    }
  }, []);
  const persistChoice = (choice: Choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        version: 1,
        choice,
        timestamp: new Date().toISOString()
      }));
    } catch {
      // ignore storage errors
    }
  };
  const handleChoice = (choice: Choice) => {
    persistChoice(choice);
    setIsMounted(false);
    setTimeout(() => setIsVisible(false), 200);
  };
  if (!isVisible) return null;
  return <div className="fixed inset-0 z-[200] flex justify-center" role="dialog" aria-modal="true" aria-labelledby="cookie-consent-title" data-id="element-86">
      {/* Backdrop — blocks interaction below */}
      <div className="absolute inset-0 bg-black/40 transition-opacity duration-300 ease-out" style={{
      opacity: isMounted ? 1 : 0
    }} data-id="element-87" />

      {/* Bottom sheet */}
      <div className="relative w-full max-w-[480px] h-full flex items-end pointer-events-none" data-id="element-88">
        <div className="w-full bg-[#141414] border-t border-[#2A2A2A] px-6 pt-6 pb-8 pointer-events-auto transition-all duration-300 ease-out" style={{
        opacity: isMounted ? 1 : 0,
        transform: isMounted ? 'translateY(0)' : 'translateY(24px)'
      }} data-id="element-89">
          <h2 id="cookie-consent-title" className="text-white text-[18px] font-semibold" data-id="element-90">
            {t('cookie.title')}
          </h2>

          <p className="text-[#AAAAAA] text-[14px] mt-3 leading-relaxed" data-id="element-91">
            {t('cookie.body')}
          </p>

          <div className="mt-6 flex flex-col gap-2" data-id="element-92">
            <button onClick={() => handleChoice('all')} className="w-full py-4 rounded-full border-[1.5px] border-[#C5D82D] text-[#C5D82D] bg-transparent text-[14px] font-semibold tracking-wide transition-colors hover:bg-[#C5D82D]/10" data-id="element-93">
              {t('cookie.acceptAll')}
            </button>

            <button onClick={() => handleChoice('essential_only')} className="w-full py-3 text-[#888888] text-[14px] font-medium transition-colors hover:text-white" data-id="element-94">
              {t('cookie.rejectNonEssential')}
            </button>
          </div>
        </div>
      </div>
    </div>;
}